"use client";
import { useState, useRef, useContext, useEffect } from "react";
import { MainContext } from "@/contexts/MainContext";

function Video({ aboutUs }) {
  if (!aboutUs.linkVideo) {
    return <div></div>;
  }

  return (
    <div className="relative w-full">
      <div className="embla__slide relative !basis-[100%]">
        <iframe
          height="50vh"
          className="w-full md:h-screen h-[40vh]"
          src={`https://www.youtube.com/embed/${aboutUs.linkVideo?.slice(
            aboutUs.linkVideo?.indexOf("=") + 1,
          )}`}
          title={`YouTube video player`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
}

export default Video;
